import type { WebchatTranslations } from '.'

export const fr: WebchatTranslations = {
  'composer.placeholder': 'Écrivez votre message...',
  'composer.sendButton.ariaLabel': 'Bouton Envoyer le message',
  'composer.voiceButton.ariaLabel': 'Bouton Saisie vocale',
  'composer.fileButton.ariaLabel': 'Bouton Téléverser un fichier',
  'composer.messageInput.ariaLabel': 'Saisie du message',

  'fileAttachment.uploadError': 'Erreur de téléversement',
  'fileAttachment.fallbackExtension': 'Fichier',
  'fileAttachment.removeButton.ariaLabel': 'Bouton Supprimer le fichier',

  'header.defaultBotName': 'Bot',
  'header.expandButton.ariaLabel': "Bouton Développer l'en-tête",
  'header.sound.enable': 'Activer les sons du chat',
  'header.sound.disable': 'Désactiver les sons du chat',

  'conversationHistory.title': 'Conversations',
  'conversationHistory.empty': 'Aucune conversation commencée',
  'conversationHistory.newConversation': 'Nouvelle conversation',
  'conversationHistory.sentAttachment': 'A envoyé une pièce jointe',
  'conversationHistory.showButton.ariaLabel': 'Bouton Afficher les conversations récentes',

  'restartConversation.title': 'Créer une nouvelle conversation',
  'restartConversation.description': 'Cela effacera la conversation en cours et en démarrera une nouvelle.',
  'restartConversation.confirm': 'Nouvelle conversation',
  'restartConversation.cancel': 'Annuler',
  'restartConversation.button.ariaLabel': 'Bouton Redémarrer la conversation',

  'closeButton.ariaLabel': 'Bouton Fermer le chatbot',

  'feedback.title': 'Aidez-nous à nous améliorer',
  'feedback.description': 'Veuillez nous faire part de vos commentaires pour nous aider à nous améliorer.',
  'feedback.confirm': 'Envoyer le commentaire',
  'feedback.cancel': 'Annuler',
  'feedback.placeholder': "Dites-nous ce qui n'a pas fonctionné...",

  'error.configuration': 'Erreur de configuration',
  'error.bot': 'Erreur du bot',
  'error.network': 'Erreur réseau',
  'error.disconnected': 'Déconnecté',
  'error.unexpected': 'Erreur inattendue',

  'dropdown.placeholder': 'Sélectionner...',

  'message.status.delivered': 'Distribué',

  'date.today': "Aujourd'hui",
  'date.yesterday': 'Hier',
}
